export enum FileContentType {
  PDF = 'application/pdf',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  PNG = 'image/png',
  JPG = 'image/jpeg',
  TIF = 'image/tiff',
}
